module.exports = __webpack_public_path__ + "assets/img/01.870d92f8.png";